import { Component, Input, OnInit } from '@angular/core';
import { Cooperative } from '../../../models/cooperatives';
import { Onboarding } from '../../../models/onboarding';
import { Product } from '../../../models/product';
import { ApiService } from '../../../services/api.service';

@Component({
  selector: 'alg-success-info',
  templateUrl: './alg-success-info.component.html',
  styleUrls: ['./alg-success-info.component.scss'],
})
export class AlgSuccessInfoComponent implements OnInit {
  public currentOnboarding: Onboarding = {} as Onboarding;
  public cooperatives: Cooperative[];
  public product: Product = {} as Product;
  public greenEnergy: boolean = false;
  public promoText: string;
  public extraPoints: string;

  @Input() showSummary: boolean = true;

  constructor(private api: ApiService) {}

  ngOnInit() {
    this.api.currentOnboarding.subscribe((onboarding: Onboarding) => {
      this.currentOnboarding = onboarding;
    });
    this.api.currentProduct.subscribe((product: Product) => {
      this.product = product;
    });
    this.api.currentLightGreen.subscribe((lightGreen) => (this.greenEnergy = lightGreen));
    this.api.promotions.subscribe((promotions) => {
      const currentPromo = promotions.find((p) => p.code === this.currentOnboarding.promoCode);
      if (currentPromo) {
        this.promoText = this.product.type === 'Luce & Gas' ? currentPromo.descriptionBi : currentPromo.descriptionMono;
      }
    });
    this.api.cooperatives.subscribe((cooperatives: Cooperative[]) => {
      this.cooperatives = cooperatives;
    });
    this.extraPoints = this.cooperatives[1].pointsFor12;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-success-info/alg-success-info.component.ts